var render = function render(){var _vm=this,_c=_vm._self._c;return _c('price-input',{ref:"input",attrs:{"name":`${_vm.name}Price`,"label":_vm.$t('WIZARD.CHANGE_IN_VALUE'),"value":_vm.value,"parse-to-number":true},on:{"input":_vm.handleInputEvent,"blur":_vm.handleBlurEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }